import { useMutation, useQueryClient } from '@tanstack/react-query';

import { setActiveRole } from '@/api/auth/set-active-role';

import { authKeys } from './query-keys';

/**
 * Switches the session's active role on the server, then invalidates
 * `/me` — `RequireAuth`'s own effect on `useCurrentUser` dispatches
 * `sessionEstablished` once that refetch resolves, the same path a fresh
 * sign-in already takes, so the store's user, permissions and every
 * `selectCan` follow the real token without this hook writing to Redux
 * itself.
 */
export const useSetActiveRole = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: setActiveRole,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: authKeys.currentUser() }),
  });
};
